import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


import ContractorAuthenticationModal from '../../../components/family-plaza/ContractorAuthenticationModal';
import PortraitPhotoRegistrationModal from '../../../components/family-plaza/PortraitPhotoRegistrationModal';
import { checkModalAuthenticationStatus } from '../../../utils/authUtils';
import { getDeceasedPersonDate, getDeceasedPersonProfileText } from '../../../utils/profilePhotoUtils';
import { getBoardList, getCherishLettersByGoinId } from '../../../api';
import CyberMemorialService from '../../../services/FamilyPlaza/CyberMemorialService';
import FamilyPlazaSubHeading from '../../../components/family-plaza/FamilyPlazaSubHeading';
import FamilyPlazaTopSection from '../../../components/family-plaza/FamilyPlazaTopSection';
import DeceasedPersonProfile from '../../../components/family-plaza/DeceasedPersonProfile';


const MemorialPostBoardListMobile = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [memorialPosts, setMemorialPosts] = useState([]);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [profilePhotoUrl, setProfilePhotoUrl] = useState('/mobile donate/group-129.png');
  const [displayedPosts, setDisplayedPosts] = useState([]);
  const [hasMorePosts, setHasMorePosts] = useState(false);
  const [postsPerPage] = useState(10);
  const [allPosts, setAllPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();

  // Handle load more posts
  const handleLoadMore = async () => {
    if (isLoading || currentPage >= Math.ceil(allPosts.length / postsPerPage)) return;
    
    setIsLoading(true);
    try {
      const nextPage = currentPage + 1;
      const startIndex = (nextPage - 1) * postsPerPage;
      const endIndex = startIndex + postsPerPage;
      
      // Get next batch of posts from allPosts
      const nextBatch = allPosts.slice(startIndex, endIndex);
      
      if (nextBatch.length > 0) {
        setDisplayedPosts(prevPosts => [...prevPosts, ...nextBatch]);
        setCurrentPage(nextPage);
        setHasMorePosts(endIndex < allPosts.length);
      }
    } catch (error) {
      console.error('Error loading more posts:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Load memorial posts from API first, then localStorage as fallback
  useEffect(() => {
    const loadMemorialPosts = async () => {
      const selectedPersonData = localStorage.getItem('selectedPersonData');
      let customerName = 'default';
      let goinId = null;
      
      if (selectedPersonData) {
        try {
          const personData = JSON.parse(selectedPersonData);
          customerName = personData.customerName || 'default';
          goinId = personData.goinId || null;
        } catch (error) {
          customerName = 'default';
        }
      }
      
      try {
        if (goinId) {
          const response = await getCherishLettersByGoinId(goinId);
          
          if (response && response.data) {
            const posts = Array.isArray(response.data) ? response.data : [];
            const processedPosts = posts.map(post => ({
              id: post.letterId || post.id,
              title: post.letterTitle || '제목 없음',
              content: post.letterContents || '',
              author: post.writerName || (post.registId ? String(post.registId) : (post.registIp || 'Anonymous')),
              writerName: post.writerName || '',
              date: post.registTime,
              isPrivate: (post.secureFlag || 'Y') === 'Y',
              password: '',
              customerName: customerName
            }));
            
                         if (processedPosts.length > 0) {
               const sortedPosts = processedPosts.sort((a, b) => {
                 const dateA = new Date(a.date);
                 const dateB = new Date(b.date);
                 return dateB - dateA;
               });
               
               setAllPosts(sortedPosts);
               setMemorialPosts(sortedPosts);
               const postsKey = `memorialPosts_${customerName}`;
               localStorage.setItem(postsKey, JSON.stringify(sortedPosts));
               
               // Show first 5 posts
               const firstPage = sortedPosts.slice(0, postsPerPage);
               setDisplayedPosts(firstPage);
               setCurrentPage(1);
               setHasMorePosts(sortedPosts.length > postsPerPage);
               return;
             }
          }
        }
      } catch (error) {
        console.log('Cherish letters API failed:', error);
      }

      // Fallback to localStorage if API fails or returns no data
      const postsKey = `memorialPosts_${customerName}`;
      const savedPosts = localStorage.getItem(postsKey);
      
             if (savedPosts) {
         try {
           const parsedPosts = JSON.parse(savedPosts);
           // Sort by date - most recent first
           const sortedPosts = parsedPosts.sort((a, b) => {
             const dateA = new Date(a.date);
             const dateB = new Date(b.date);
             return dateB - dateA; // Descending order (newest first)
           });
           setAllPosts(sortedPosts);
           setMemorialPosts(sortedPosts);
           
           // Show first 5 posts
           const firstPage = sortedPosts.slice(0, postsPerPage);
           setDisplayedPosts(firstPage);
           setCurrentPage(1);
           setHasMorePosts(sortedPosts.length > postsPerPage);
         } catch (error) {
           setMemorialPosts([]);
           setDisplayedPosts([]);
           setAllPosts([]);
           setHasMorePosts(false);
         }
       } else {
         setMemorialPosts([]);
         setDisplayedPosts([]);
         setAllPosts([]);
         setHasMorePosts(false);
       }
    };

    loadMemorialPosts();
  }, []);



  // Listen for memorial post updates
  useEffect(() => {
    const handleMemorialPostUpdate = (event) => {
      const selectedPersonData = localStorage.getItem('selectedPersonData');
      let customerName = 'default';
      
      if (selectedPersonData) {
        try {
          const personData = JSON.parse(selectedPersonData);
          customerName = personData.customerName || 'default';
        } catch (error) {
          customerName = 'default';
        }
      }
      
             if (event.detail.customerName === customerName) {
         const postsKey = `memorialPosts_${customerName}`;
         const savedPosts = localStorage.getItem(postsKey);
         if (savedPosts) {
           try {
             const parsedPosts = JSON.parse(savedPosts);
             // Sort by date - most recent first
             const sortedPosts = parsedPosts.sort((a, b) => {
               const dateA = new Date(a.date);
               const dateB = new Date(b.date);
               return dateB - dateA; // Descending order (newest first)
             });
             setAllPosts(sortedPosts);
             setMemorialPosts(sortedPosts);
             
             // Show first 5 posts
             const firstPage = sortedPosts.slice(0, postsPerPage);
             setDisplayedPosts(firstPage);
             setCurrentPage(1);
             setHasMorePosts(sortedPosts.length > postsPerPage);
           } catch (error) {
             setMemorialPosts([]);
             setDisplayedPosts([]);
             setAllPosts([]);
             setHasMorePosts(false);
           }
         }
       }
    };

    window.addEventListener('memorialPostUpdated', handleMemorialPostUpdate);
    return () => {
      window.removeEventListener('memorialPostUpdated', handleMemorialPostUpdate);
    };
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleNavigation = (route) => {
    navigate(route);
  };

  const handleMemorialPost = () => {
    navigate('/cyber-memorial-search');
  };

  const handleWritePost = () => {
    // Check modal authentication status first
    if (checkModalAuthenticationStatus()) {
      // Clear any existing selected post data to ensure fresh writing mode
      localStorage.removeItem('selectedMemorialPost');
      navigate('/memorial-post-writing');
    } else {
      // Show authentication modal first
      setShowAuthModal(true);
    }
  };

  const handleWriteButton = () => {
    // Clear any existing selected post data to ensure fresh writing mode
    localStorage.removeItem('selectedMemorialPost');
    navigate('/memorial-post-writing');
  };

  // Photo icon click handler
  const handlePhotoIconClick = () => {
    if (checkModalAuthenticationStatus()) {
      setShowPhotoModal(true);
    } else {
      setShowAuthModal(true);
    }
  };

  // Authentication modal handlers
  const handleAuthConfirm = () => {
    setShowAuthModal(false);
    // Navigate to writing page after successful authentication
    localStorage.removeItem('selectedMemorialPost');
    navigate('/memorial-post-writing');
  };

  const handleAuthClose = () => {
    setShowAuthModal(false);
  };

  // Photo registration modal handlers
  const handlePhotoConfirm = () => {
    setShowPhotoModal(false);
  };

  const handlePhotoUpload = (photoUrl) => {
    setProfilePhotoUrl(photoUrl);
  };

  const handlePhotoClose = () => {
    setShowPhotoModal(false);
  };

  const handleLetterToHeaven = () => {
    navigate('/letter-to-heaven-board-list');
  };

  const handleManagementInquiry = () => {
    navigate('/management-search');
  };

  const handleAncestralTablet = () => {
    navigate('/ancestral-tablet');
  };

  const handlePostClick = (postId) => {
    // Save the selected post data to localStorage for details page
    const selectedPost = memorialPosts.find(post => post.id === postId);
    if (selectedPost) {
      localStorage.setItem('selectedMemorialPost', JSON.stringify(selectedPost));
      navigate('/memorial-post-details');
    }
  };

  return (
    <div className="memorial-post-board-list-mobile-unique announcement-list-page cyber-info-page-pc">

    <FamilyPlazaTopSection />

    <main className="main-content">

    <FamilyPlazaSubHeading heading="사이버추모관" />


       <DeceasedPersonProfile 
        handlePhotoIconClick={handlePhotoIconClick}
        />
      

      {/* Navigation Tabs */}
      <div className="memorial-post-board-list-mobile-nav-tabs-unique">
        <button 
          className="memorial-post-board-list-mobile-nav-tab-unique"
          onClick={() => navigate('/donate')}
        >
          <span>헌화하기</span>
        </button>
        <button 
          className="memorial-post-board-list-mobile-nav-tab-unique memorial-post-board-list-mobile-nav-tab-active-unique"
          onClick={() => navigate('/memorial-post-board-list')}
        >
          <span>추모글</span>
        </button>
        <button 
          className="memorial-post-board-list-mobile-nav-tab-unique"
          onClick={() => navigate('/memorial-album-board-list')}
        >
          <span>추모앨범</span>
        </button>
      </div>

        {/* Write Post Button */}
        <div className="memorial-post-board-list-mobile-button-section-unique">
        <button 
          className="memorial-post-board-list-mobile-write-button-unique"
          onClick={handleWritePost}
        >
          글쓰기
        </button>
      </div>

             {/* Content Cards */}
       <div className="memorial-post-board-list-mobile-content-cards-unique">
         {/* Show user's memorial posts first (latest first) */}
         {displayedPosts.map((post) => (
           <div key={post.id} className="memorial-post-board-list-mobile-content-card-unique" onClick={() => handlePostClick(post.id)}>
             <div className="memorial-post-board-list-mobile-card-title-unique">
               {post.title}
             </div>
             <div className="memorial-post-board-list-mobile-card-sender-unique">
               From {post.writerName || post.customerName} | {new Date(post.date).toLocaleDateString('ko-KR', {
                 year: 'numeric',
                 month: '2-digit',
                 day: '2-digit'
               }).replace(/\. /g, '.').replace(/\.$/, '')}
             </div>
           </div>
         ))}
       </div>

             {/* Load More Button */}
       {hasMorePosts && (
         <div className="memorial-post-board-list-mobile-more-section-unique">
           <button 
             className="memorial-post-board-list-mobile-load-more-btn-unique"
             onClick={handleLoadMore}
             disabled={isLoading}
           >
             {isLoading ? '로딩 중...' : '더보기'}
           </button>
         </div>
       )}

    



      {/* Authentication Modal */}
      <ContractorAuthenticationModal
        isOpen={showAuthModal}
        onConfirm={handleAuthConfirm}
        onClose={handleAuthClose}
      />

      {/* Photo Registration Modal */}
      <PortraitPhotoRegistrationModal
        isOpen={showPhotoModal}
        onConfirm={handlePhotoConfirm}
        onClose={handlePhotoClose}
        onPhotoUpload={handlePhotoUpload}
      />
    </main>

    </div>
  );
};

export default MemorialPostBoardListMobile; 